import { getRemovedBundleSelectionChangedNotification } from '../helpers/bundleSelection'

export const showRemovedBundleSelectionChangedAlert = removedItems => dispatch => {
  const notification = getRemovedBundleSelectionChangedNotification(removedItems)
  if (!notification) return

  const productLink = notification.productPath && notification.productName

  dispatch({
    type: 'SHOW_SWEETALERT',
    payload: {
      type: 'warning',
      title: 'Your cart was updated',
      alertMessage: (
        <div>
          <div>{notification.message}</div>
          {productLink && (
            <a
              className="d-inline-block mt-2"
              href={notification.productPath}
              onClick={() => dispatch({ type: 'CLEAR_SWEETALERT' })}
            >
              View {notification.productName}
            </a>
          )}
        </div>
      ),
      showCancel: false,
      confirmBtnText: 'OK'
    }
  })
}
